import React from 'react';
import { ResponsiveContainer, AreaChart, Area, XAxis, YAxis, Tooltip, ReferenceLine } from 'recharts';
import { fmtR, fmtMoney } from '../../lib/tradeUtils';

export default function RChart({ data, mode = 'R' }) {
  const isR = mode === 'R';
  const cumKey = isR ? 'cumulative_r' : 'cumulative_pnl';
  const valKey = isR ? 'r' : 'pnl';
  const fmt = (v) => (isR ? fmtR(v, 1) : fmtMoney(v, true));

  const points = [{ index: 0, cumulative_r: 0, cumulative_pnl: 0, r: 0, pnl: 0, ticker: null }, ...(data || [])];
  const last = points[points.length - 1]?.[cumKey] ?? 0;
  const color = last >= 0 ? '#15E402' : '#F87171';

  const Tip = ({ active, payload }) => {
    if (!active || !payload || !payload.length) return null;
    const p = payload[0].payload;
    return (
      <div className="rounded-lg border border-white/10 bg-black/90 px-3 py-2 text-xs shadow-xl">
        <div className="font-semibold text-white">{p.ticker ? `#${p.index} · ${p.ticker}` : `Trade ${p.index}`}</div>
        <div className="mt-0.5 text-zinc-400">Trade: <span className={(p[valKey] ?? 0) >= 0 ? 'text-emerald' : 'text-red-400'}>{fmt(p[valKey])}</span></div>
        <div className="text-zinc-400">Cumulative: <span className={p[cumKey] >= 0 ? 'text-emerald' : 'text-red-400'}>{fmt(p[cumKey])}</span></div>
      </div>
    );
  };

  return (
    <div className="h-56 w-full" data-testid="r-chart">
      <ResponsiveContainer width="100%" height="100%">
        <AreaChart data={points} margin={{ top: 10, right: 8, left: -6, bottom: 0 }}>
          <defs>
            <linearGradient id="rFill" x1="0" y1="0" x2="0" y2="1">
              <stop offset="0%" stopColor={color} stopOpacity={0.18} />
              <stop offset="100%" stopColor={color} stopOpacity={0} />
            </linearGradient>
          </defs>
          <XAxis dataKey="index" tick={{ fill: '#71717a', fontSize: 11 }} axisLine={false} tickLine={false} />
          <YAxis tick={{ fill: '#71717a', fontSize: 11 }} axisLine={false} tickLine={false} width={48}
            tickFormatter={(v) => (isR ? `${v}R` : fmtMoney(v))} />
          <ReferenceLine y={0} stroke="#3f3f46" strokeDasharray="3 3" />
          <Tooltip content={<Tip />} />
          <Area type="monotone" dataKey={cumKey} stroke={color} strokeWidth={2} fill="url(#rFill)" dot={false} activeDot={{ r: 4, fill: color }} />
        </AreaChart>
      </ResponsiveContainer>
    </div>
  );
}
